import { ActionContext, IActionContext } from '../helpers/ActionContext';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export abstract class AbstractContentAction<TContentItem extends INamedItemInfo> {

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    public ContentActionNotification: ContentActionNotification) { }

  public executeFromEvent(contentItems: Set<TContentItem>, $event: JQueryEventObject): ng.IPromise<IResult> {
    return this.execute(contentItems, ActionContext.fromEvent($event));
  }

  public execute(contentItems: Set<TContentItem>, actionContext: IActionContext): ng.IPromise<IResult> {

    const dialogConfig = this.defaultDialogConfig(actionContext);
    this.configureDialog(dialogConfig, contentItems);

    const dialogInstance = this.ConfirmActionDialog.open(dialogConfig);

    dialogInstance.result.then((result: IResult) =>
      this.ContentActionNotification.notifyResult(contentItems, result.errors, this.notificationTranslationIds(), this.notificationTranslationValues(dialogConfig.scope)));

    dialogInstance.result.finally(() => dialogConfig.scope.$destroy());
    return dialogInstance.result;
  }

  private defaultDialogConfig(actionContext: IActionContext): IConfirmActionDialogOptions {
    return {
      scope: actionContext.scope.$new(),
      title: '',
      actionName: 'OK',
      action: angular.noop
    };
  }

  // Override in action implementations
  configureDialog(dialogConfig: IConfirmActionDialogOptions, contentItems: Set<TContentItem>) {}

  notificationTranslationIds(): INotificationTranslationIds {
    throw 'notificationTranslationIds() must be implemented in a subclass';
  }

  notificationTranslationValues(dialogScope: ng.IScope): Object {
    return {};
  }

}
